export const levelThreeStyles = {
  container: (showBorder?: boolean) => {
    return {
      marginTop: 0.5,
      borderLeft: showBorder ? '1px solid' : undefined,
      borderLeftColor: showBorder ? 'divider' : undefined,
      width: '100%',
      overflow: 'auto',
      display: 'flex',
      height: 'auto'
    };
  },
  menuSection: {
    padding: '0px 0px 8px 0px',
    marginRight: 1,
    color: 'text.primary',
    border: 'none',
    boxShadow: 'none'
  }
};
